import { render, staticRenderFns } from "./brand-news.vue?vue&type=template&id=7a147aaf&scoped=true&"
import script from "./brand-news.vue?vue&type=script&lang=js&"
export * from "./brand-news.vue?vue&type=script&lang=js&"
import style0 from "./brand-news.vue?vue&type=style&index=0&id=7a147aaf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a147aaf",
  null
  
)

export default component.exports